import {
  DateInput,
  SimpleForm,
  SimpleFormProps,
  required
} from 'react-admin';

import { dateFormatter } from '../../utils'


export default function VisitBlockedDaysForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      
      <DateInput
        autoComplete="off"
        format={dateFormatter}
        label="Data"
        source="day"
        validate={[required()]}
      />

    </SimpleForm>
  );
}
